import React from "react";
import "./App.css";
import {Navbar} from "./Components/Navbar/navbar";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Home from "./Pages/Home/home";
import RsvpForm from "./Pages/RSVP/rsvp";
import { Divider, Fade, Typography } from "@mui/material";
import Countdown, { weddingDay } from "./Components/Countdown/countdown";
import Schedule from "./Pages/Schedule/schedule";

declare module "@mui/material/styles" {
  interface Theme {
    text?: {
      primary?: {
        fontSize?: string;
      };
    };
  }

  interface ThemeOptions {
    text?: {
      primary?: {
        fontSize?: React.CSSProperties["fontSize"];
        color?: React.CSSProperties["color"];
      };
    };
  }
}
const theme = createTheme({
  palette: {
    primary: { main: "#006B3E"  },
    secondary: { main: '#f9f9f9'},
    text: { primary: "#000000", secondary: '#3B3B3B' },
  },
  typography: {
    fontFamily: "Marcellus", h5: { color: '#3B3B3B'},
  },
});


function App() {
  const timeBetween = weddingDay - Date.now();
  const days = Math.floor(timeBetween / (1000 * 60 * 60 * 24));

  return (
    <ThemeProvider theme={theme}>
      <Navbar />
      <div id="home" ></div>
      <Fade
  
        in={true}
        timeout={{ enter: 1500, exit: 500 }}
      >
        <div>
          <Home />
        </div>
      </Fade>
      
      <div style={{ marginTop: "8px" }}>
        <Typography
          display="flex"
          justifyContent="center"
          alignItems="center"
          variant="h2"
          color="rgba(0, 0, 0, 0.8)"
          fontFamily={"Meow Script"}
        >
          {days} Days!
        </Typography>
        <Divider style={{ margin: "32px 32px 32px 32px" }}>
          <Countdown />
        </Divider>
      </div>
    
      <RsvpForm />
      <Schedule />
    </ThemeProvider>
  );
}

export default App;
